import { ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ViewStateRecord } from '@common/data-models/records/viewstate-record';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { LayoutState } from '@common/services/layout-state';
import { NavigationService } from '@common/services/navigation-service';
import { PublicationChannelsService } from '@common/services/publication-channels-service';
import { NavigationGroup, NavigationItem, NavigationSection } from '@common/store/navigation/models/navigation.models';
import { AppService } from '@src/suite/app.service';
import { ViewStateTypes } from '@src/suite/common/enums/viewstate-types';
import { CreateViewStateActions } from '@src/suite/common/store/createviewstate/createviewstate.actions';
import {
    selectCreateViewStateEditionName,
    selectCreateViewStateFilterPublicationTime,
    selectCreateViewStateLayout,
    selectCreateViewStatePlaybookViewStateRecords,
    selectCreateViewStatePublicationChannelEditionsList,
    selectCreateViewStatePublicationListTitle,
    selectCreateViewStateRemoveAddedRecords,
    selectCreateViewStateSelectedDefaultView,
    selectCreateViewStateSelectedEditionName,
    selectCreateViewStateSelectedPublicationChannel,
    selectCreateViewStateShowAssignments,
    selectCreateViewStateShowStories,
    selectCreateViewStateShowTopics,
} from '@src/suite/common/store/createviewstate/createviewstate.selectors';
import { selectPublicationChannelsArray } from '@src/suite/common/store/records/records.selectors';

import { BaseViewState } from './base-view-state';

@Component({
    selector: 'st-cast-view-state',
    templateUrl: './cast-view-state.html',
    styleUrls: ['./cast-view-state.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-cast-view-state',
    },
})
export class CastViewStateComponent extends BaseViewState {
    viewStateShowStories$ = this.store.select(selectCreateViewStateShowStories);
    viewStateRemoveAddedRecords$ = this.store.select(selectCreateViewStateRemoveAddedRecords);

    selectedDefaultView$ = this.store.select(selectCreateViewStateSelectedDefaultView);
    selectedEditionName$ = this.store.select(selectCreateViewStateSelectedEditionName);
    editionName$ = this.store.select(selectCreateViewStateEditionName);

    publicationListTitle$ = this.store.select(selectCreateViewStatePublicationListTitle);

    publicationTime = this.store.selectSignal(selectCreateViewStateFilterPublicationTime);
    viewStateLayout = this.store.selectSignal(selectCreateViewStateLayout);
    viewStateShowTopics = this.store.selectSignal(selectCreateViewStateShowTopics);
    viewStateShowAssignments = this.store.selectSignal(selectCreateViewStateShowAssignments);
    editionsList = this.store.selectSignal(selectCreateViewStatePublicationChannelEditionsList);
    playbookViewStateRecords = this.store.selectSignal(selectCreateViewStatePlaybookViewStateRecords);
    selectedPublicationChannel = this.store.selectSignal(selectCreateViewStateSelectedPublicationChannel);
    publicationChannelRecords = this.store.selectSignal(selectPublicationChannelsArray);
    constructor(
        public appService: AppService,
        public globalTablesService: GlobalTablesService,
        public publicationChannelsService: PublicationChannelsService,
        public languageSettings: LanguageSettings,
        public viewStateService: LayoutState,
        public navigationService: NavigationService,
        public dialogRef: MatDialogRef<CastViewStateComponent>,
        public changeDetectorRef: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            copy: boolean;
            edit: boolean;
            vs: ViewStateRecord;
            group: NavigationGroup;
            section: NavigationSection;
            item: NavigationItem;
        }
    ) {
        super();
        this.store.dispatch(
            CreateViewStateActions.initializeViewState({
                vstype: ViewStateTypes.PUBLICATION,
                copy: data.copy,
                edit: data.edit,
                vs: data.vs,
                group: data.group,
                section: data.section,
                item: data.item,
            })
        );
    }

    updateShowTopics(checked: boolean) {
        this.store.dispatch(CreateViewStateActions.updateViewStateShowTopics({ show: checked }));
    }
    updateShowAssignments(checked: boolean) {
        this.store.dispatch(CreateViewStateActions.updateViewStateShowAssignments({ show: checked }));
    }
    updateShowStories(checked: boolean) {
        this.store.dispatch(CreateViewStateActions.updateViewStateShowStories({ show: checked }));
    }
    updateRemoveAddedRecords(checked: boolean) {
        this.store.dispatch(CreateViewStateActions.updateViewStateRemoveAddedRecords({ remove: checked }));
    }
    updateEditionName(name: string) {
        this.store.dispatch(CreateViewStateActions.updateViewStateEditionName({ name: name }));
    }
    updateViewStateGUID(guid: string) {
        this.store.dispatch(CreateViewStateActions.updateViewStateGuid({ guid: guid }));
    }
    updatePublicationChannelGUID(guid: string) {
        this.store.dispatch(CreateViewStateActions.updateViewStatePublicationChannelGuid({ guid: guid }));
    }
    updatePublicationListTitle(title: string) {
        this.store.dispatch(CreateViewStateActions.updateViewStatePublicationListTitle({ title: title }));
    }
    updatePublicationTime(time: string) {
        this.store.dispatch(CreateViewStateActions.updateViewStatePublicationTime({ time: time }));
    }
}
